import { RegisterFormModel } from "./RegisterFormModel";

export const RegisterFormInitialValues = {
  personalDetails: {
    firstName: "",
    secondName: "",
    userName: "",
    password: "",
    confirmPassword: "",
    email: "",
  },
  organisationDetails: {
    name: "",
    billingEmail: "",
    currencyCode: "",
    address: {
      firstLine: "",
      secondLine: "",
      city: "",
      state: "",
      postCode: "",
      countryId: "",
    },
    phone: "",
  },
} as RegisterFormModel;
